<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="out-grid-photo">
    <img
      src="https://firebasestorage.googleapis.com/v0/b/storage-image-app-menu.appspot.com/o/sapori-miei-storage%2Fimg-20240321-wa0008-65fc6cc2a41c9.webp?alt=media&token=8e1ad14a-158c-4b56-9037-e86b5bf8ee97"
      alt="">
  </div>
  <div class="photo-gallery">

    <div v-for="(photo, index) in pubPhotos" :key="index" class="photo-item">
      <img :src="photo" :alt="'Foto ' + (index + 1)" class="pub-photo" @click="openImage(photo)" />
    </div>
  </div>
  <div class="out-grid-photo">
    <img
      src="https://firebasestorage.googleapis.com/v0/b/storage-image-app-menu.appspot.com/o/sapori-miei-storage%2Fimg-20240321-wa0007-65fc0b2c05303.webp?alt=media&token=1952e990-6a0b-497b-adb0-1825e21c9292"
      alt="">
  </div>
  <div id="image-overlay" @click="closeImage" v-if="selectedImage">
    <img :src="selectedImage" alt="Selected Image" id="expandedImage">
  </div>
</template>
<script>

export default {
  data() {
    return {
      pubPhotos: [
        'http://ajgw3us0nspzo7gytwy4g381.79.143.179.101.sslip.io/uploads/1777737701980-image_1777737698774_oumsez.webp',
        'https://ajgw3us0nspzo7gytwy4g381.79.143.179.101.sslip.io/uploads/494902132_18142666777390382_57470964802215769_n.jpg',
        'https://ajgw3us0nspzo7gytwy4g381.79.143.179.101.sslip.io/uploads/495334822_1226798932787673_4914345078055331885_n.jpg',
        'https://ajgw3us0nspzo7gytwy4g381.79.143.179.101.sslip.io/uploads/525257642_18151030999390382_2750221991268579685_n.jpg',
        'http://ajgw3us0nspzo7gytwy4g381.79.143.179.101.sslip.io/uploads/1777737730652-image_1777737728125_ya9fe5.webp',
        'http://ajgw3us0nspzo7gytwy4g381.79.143.179.101.sslip.io/uploads/1777737746657-image_1777737744097_u8bsd7.webp',
 
      ],
      selectedImage: null
    };
  },
  methods: {
    openImage(image) {
      this.selectedImage = image;
    },
    closeImage() {
      this.selectedImage = null;
    },
  },
};
</script>
<style>
#expandedImage {
  max-width: 80%;
  max-height: 80%;
  border: 2px solid white;
  border-radius: 5px;
}

.photo-gallery {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin: 20px;

}

.photo-item {
  margin: 2px;
  overflow: hidden;
  border-radius: 8px;
  border-color: var(--border-color);
  box-shadow: var(--custom-box-shadow);
  line-height: 0;

}

#image-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.pub-photo {
  height: 100px;
}

.out-grid-photo img {
  width: 90%;
  /* L'immagine occupa l'intera larghezza del contenitore */
  height: auto;
  /* L'altezza si adatta automaticamente mantenendo le proporzioni originali */
  object-fit: contain;
  border-radius: 30px;
  box-shadow: var(--custom-box-shadow);

}
</style>
